import { HelixIcon } from '@helix/helix-icon'
import { circle_checkmark as CheckmarkIcon } from '@helix/helix-icon/solid'
import { ReactNode } from 'react'

interface AccountBannerProps {
  children: ReactNode
}

export function AccountBanner({ children }: AccountBannerProps) {
  return (
    <div className="helix-bg-green-50 helix-text-green-900 !mt-2 flex items-center px-3 py-2 text-sm font-medium">
      <HelixIcon
        icon={CheckmarkIcon}
        className="helix-svg-fill--green-600 mx-4 h-4 w-4 flex-shrink-0"
        aria-hidden
      />
      <span>{children}</span>
    </div>
  )
}
